import React, { useCallback, useEffect } from 'react'
import './ChooseIcon.scss'
import { ProfileTitle } from '@components/Profile/ProfileTitle/ProfileTitle'
import { VelvetSDK } from 'sdk'
import { ProfileIcon } from '@components/Profile/ProfileIcon/ProfileIcon'
import { Params, useNavigate, useParams } from 'react-router-dom'
import { useUserProfile } from '@hooks/useUserProfile'
import DotSpinner from '@components/DotSpinner/DotSpinner'
import classNames from 'classnames'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { RailProfileImages } from '@components/Rails/RailProfileImages/RailProfileImages'
import SpatialNavigation from '@utils/spatial-navigation.js'
import { onBackKeyPress } from '@utils/helpers'
import { getEditProfileIdRoute } from '@constants/routes.const'
import { ProfileImagesType } from 'sdk/services/config/types/config'

interface ChooseIconProps {
  showMenu: (status: boolean) => void
}

export const ChooseIcon = ({ showMenu }: ChooseIconProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const imageRails = VelvetSDK.Configuration.configuration.profileImages
  const SN = SpatialNavigation
  const navigate = useNavigate()
  const { profileId } = useParams<Params>()
  const { profileData, isLoading } = useUserProfile({
    profileId: profileId || '',
  })

  const backToManageProfilePage = useCallback(
    (e: KeyboardEvent) =>
      onBackKeyPress(e, () => {
        navigate(getEditProfileIdRoute(profileId))
      }),
    [navigate, profileId],
  )

  useEffect(() => {
    showMenu(false)
  }, [showMenu])

  useEffect(() => {
    document.addEventListener('keydown', backToManageProfilePage)
    return () => {
      document.removeEventListener('keydown', backToManageProfilePage)
    }
  }, [backToManageProfilePage])

  useEffect(() => {
    if (!isLoading && imageRails && imageRails.length > 0) {
      SN.focus(`#rail-${imageRails[0].id}`)
    }
  }, [isLoading, imageRails, SN])

  if (isLoading) return <DotSpinner />

  return (
    <div className="choose-icon-page">
      <div className="title-wrapper">
        <ProfileTitle title={V.profilePickAnIcon} />
        <div className="profile-data">
          <Text tag={TextTag.P}>
            {V.profileForLabel} {profileData?.name}
          </Text>
          <div
            className={classNames('profile-picture-wrapper', profileData?.image.type)}
            style={{ backgroundColor: `${profileData?.image.backgroundColor}` }}
          >
            <ProfileIcon profileData={profileData} />
          </div>
        </div>
      </div>
      <div className="image-carousels">
        {profileData &&
          imageRails?.map((rail: ProfileImagesType) => {
            return (
              <>
                <Text tag={TextTag.H1}>{V[rail.title]}</Text>
                <RailProfileImages
                  key={rail.id}
                  items={rail.data}
                  profileData={profileData}
                  railId={`rail-${rail.id}`}
                />
              </>
            )
          })}
      </div>
    </div>
  )
}
